<template>
    <tab-layout>
        <template #title> </template>

        <!-- TAB CONTENT -->
        <template #content>
            <div class="well ovy-auto hp-10 tab__container">
                <div class="tab-header__container flex-row">
                    <div ref="tab-header__heading" class="typographies-heading-h3">
                        {{ currentPipeline }}
                    </div>

                    <CompassButton
                        :label="$t.__('common.actions.edit')"
                        type="secondary"
                        size="small"
                        @click="toPipelineParams"
                    />
                </div>

                <section class="flex tab-list_container">
                    <ul class="tab-list_items my-0">
                        <p class="gray-80 py-2 fs-2 pl-2 m-0 flex-row">
                            <span class="pr-3">{{ $l10n.__('PROBABILITÉ') }}</span
                            >{{ $l10n.__('ÉTAPE') }}
                        </p>

                        <li
                            v-for="step in steps"
                            :key="step.id"
                            class="tab-list__item--wrapper flex-column"
                            :class="stepClasses(step.id)"
                            @mouseover="stepIsHovered(step.id)"
                            @mouseleave="stepIsHovered(null)"
                        >
                            <div
                                class="tab-list--separator ml-3"
                                :class="isActiveSeparator(step.id)"
                            />

                            <div class="flex-row tab-list_item">
                                <div class="flex-row">
                                    <span class="lh-20 mr-3 tab-list_item--left"
                                        >{{ step.probability }}%</span
                                    >
                                    <span class="lh-20">
                                        {{ step.name }}
                                    </span>
                                </div>
                                <CompassPlainButton
                                    v-if="isStepHovered(step.id)"
                                    :label="$t.__('overview.tabs.TabPipeline.skip_step')"
                                    type="tertiary"
                                    size="small"
                                    class="tab-list_item--action"
                                    :loading="isLoaded"
                                    @click="updateOpportunityStep(step)"
                                />
                            </div>
                        </li>
                    </ul>
                </section>
            </div>
        </template>
    </tab-layout>
</template>

<script>
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

export default {
    components: {
        TabLayout,
    },
    data() {
        return {
            showUpdateBtn: null,
            isLoaded: false,
        };
    },
    computed: {
        informations() {
            return this?.$store?.getters?.dataFetch || {};
        },
        steps() {
            return this.informations?.informations?.find((index) => index.key === 'steps')?.value;
        },
        activeStep() {
            return this.informations?.informations?.find((index) => index.key === 'stepId')?.value;
        },
        id() {
            return this.informations?.informations?.find((index) => index.key === 'id')?.value;
        },
        permissions() {
            return this.$store?.getters?.permissions || {};
        },
        currentPipeline() {
            return this.informations?.informations?.find((index) => index.key === 'funnelName')
                ?.value;
        },
    },
    methods: {
        isStepHovered(stepId) {
            return (
                this.showUpdateBtn === stepId &&
                this.activeStep !== stepId &&
                this.permissions.can_edit
            );
        },
        stepIsHovered(stepId) {
            this.showUpdateBtn = stepId;
        },
        stepClasses(stepId) {
            return {
                'is-active': this.activeStep >= stepId,
                'is-current': this.activeStep === stepId,
                'can-edit': !!this.permissions.can_edit,
            };
        },
        isActiveSeparator(stepId) {
            return this.activeStep >= stepId ? 'bl-2-primary-50' : 'bl-2-gray-60';
        },

        updateOpportunityStep(step) {
            if (this.permissions.can_edit) {
                const hasAutomation = step.hasAutomation;
                this.isLoaded = true;

                if (hasAutomation) {
                    this.$confirm(
                        this.$l10n.__(
                            "Une action d’envoi automatique d'email est activée sur cette étape. Confirmez-vous l'envoi de cet l’email ?",
                        ),
                        '',
                        {
                            confirmButtonText: this.$l10n.__("Envoyer l'email"),
                            cancelButtonText: this.$l10n.__("Ne pas envoyer l'email"),
                            confirmButtonClass: 'btn btn-primary',
                            cancelButtonClass: 'btn btn-default',
                        },
                    )
                        .then(() => {
                            // Send email confirmed on modal
                            this.setStep(step.id, false);
                        })
                        .catch(() => {
                            // Stop email on modal
                            this.setStep(step.id, true);
                        });
                } else {
                    this.setStep(step.id, true);
                }
            }
        },

        setStep(stepId, skipAutomation) {
            this.$ajax.put(
                `/rest/prospection/opportunities/${this.id}/step`,
                { _output: 'overview' },
                { stepId: stepId, skipAutomation },
                () => {
                    if (!skipAutomation) {
                        Push.success(this.$l10n.__('Email(s) envoyé(s)'), false);
                    }
                    Push.success(
                        this.$l10n.__("L'étape de l'opportunité a été mise à jour."),
                        false,
                    );
                    this.$store.dispatch('updateOpportunityStepId', stepId);
                    this.isLoaded = false;
                },
                () => {
                    Push.error(this.$l10n.__('Une erreur est survenue lors de la mise à jour.'));
                    this.isLoaded = false;
                },
            );
        },
        toPipelineParams() {
            this.permissions.can_access_pipeline_settings
                ? (window.location.href = '/?_f=prospection_prefs&action=funnels')
                : Push.error(
                      this.$l10n.__(
                          'Vous n’avez pas les privileges pour accèder à cette ressource.',
                      ),
                  );
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.tab__container {
    .tab-header__container {
        justify-content: space-between;
        text-align: left;
    }
    .tab-list_container {
        width: 696px;
        margin: 6px auto 0;

        .tab-list_items {
            & > p {
                line-height: 16px;
                text-align: left;
                font-weight: 600;
                & > span {
                    width: 80px;
                    margin-right: 16px;
                }
            }
            .tab-list__item--wrapper {
                .tab-list--separator {
                    height: 16px;
                }
                &.is-active {
                    color: $gray-60;

                    &.is-current {
                        .tab-list_item {
                            background: $primary-50;
                        }
                        .tab-list_item--left,
                        .tab-list_item {
                            color: $white;
                        }
                    }
                }

                &.can-edit:not(.is-current) .tab-list_item {
                    &:hover {
                        span {
                            cursor: default;
                        }
                        background: $primary-05;
                        &,
                        .tab-list_item--left {
                            color: $gray-100;
                        }
                    }
                }
                .tab-list_item {
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 8px;
                    height: 44px;
                    font-size: 14px;
                    border-radius: 4px;
                }
                .tab-list_item--left {
                    width: 80px;
                    color: $gray-60;
                    font-weight: 600;
                }
            }
        }
    }
}
</style>
